import Lottie from "lottie-react";
import loadingAnim from "../../../../../../assets/animations/pleasewait.json";
import { StepBody, StepHeader, StepNav } from "../Hikvision/HikvisionWizardParts";

const WizardStepCamectPingTest = ({ onClose }) => (
    <>
        <StepHeader title="Testing connection" subtitle="Connecting to the Camect, please wait..." />
        <StepBody style={{ alignItems: "center", justifyContent: "center" }}>
            <Lottie animationData={loadingAnim} loop style={{ width: 260, height: 260 }} />
        </StepBody>
        <StepNav onClose={onClose} />
    </>
);

export default WizardStepCamectPingTest;
